import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const DropdownWrapper = styled.div`
  position: absolute;
  right: ${pxToRem('-8px')};
  top: ${pxToRem('25px')};
  width: inherit;
  max-height: ${pxToRem('272px')};
  border-radius: ${pxToRem('8px')};
  box-shadow: 0 ${pxToRem('12px')} ${pxToRem('24px')} ${pxToRem('8px')}
    ${props => props.theme.colors.blue.six};
  border: solid ${pxToRem('1px')} ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.white};
  /*display: flex;
  flex-direction: column;*/
  z-index: 100;
  justify-content: space-around;
  padding: ${pxToRem('10px')};
  overflow-y: scroll;
`;

export const Item = styled.div`
  padding: ${pxToRem('8px')};
  text-align: left;
  border-radius: ${pxToRem('10px')};
  display: block;
  font-weight: 500;
  ${props =>
    !props.isNotClickable &&
    css`
      :hover {
        cursor: ${props => (props.readonly ? 'default' : ' pointer')};
        background-color: ${props => props.theme.colors.blue.five};
        font-weight: 600;
      }
    `}
  gap: ${pxToRem('10px')};
`;

export const DownArrow = styled.div`
  cursor: pointer;
  border: solid #467afb;
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};

  transform: ${props =>
    props.upsideDown ? 'rotate(45deg)' : 'rotate(225deg)'};
  -webkit-transform: ${props =>
    props.upsideDown ? 'rotate(45deg)' : 'rotate(225deg)'};
  transition-duration: 0.5s;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  -moz-transition-property: transform;
`;

export const ArrowContainer = styled.div`
  position: relative;
  margin-right: ${pxToRem('2px')};

  opacity: 0;
  transition: all 250ms;
  ${({ isEditing }) =>
    isEditing &&
    css`
      opacity: 1;
    `}
`;

export const Input = styled.input`
  font-family: 'OpenSans';
  background-color: transparent;
  border: none;
  width: calc(100% - ${({ icon }) => (icon ? 50 : 5)}px);

  :focus {
    outline: none;
  }

  cursor: ${props => (props.readonly ? 'default' : ' pointer')};
  font-size: ${pxToRem('16px')};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black.one};
  border: none;
  transition: border 0.5s;

    ::placeholder {
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  ::-webkit-input-placeholder {
    /* Edge */
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}

  ${({ readonly }) =>
    readonly &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${props =>
    props.isEditable &&
    !props.isLeadDetail &&
    css`
      border-bottom: ${pxToRem('1px')} solid ${props.theme.colors.black.one};
    `}
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: ${pxToRem('6px')};
  padding: ${props => (props.padding ? `${props.padding}` : 'unset')};
  display: flex;
  align-items: center;
  ${({ disabled, readonly }) =>
    disabled &&
    !readonly &&
    css`
      cursor: not-allowed;
    `};

  ${({ readonly, theme }) =>
    readonly &&
    css`
      pointer-events: none;
      border: none;
      background-color: ${theme.colors.transparent};
    `};
`;
